import axios from "axios";
import { getAuthHeader, catchApi } from "../../utils";
import { cachedGet } from "../../utils/apiResponseCache";

const CURRENT_VESSEL_KEY = "user:current-vessel";
const CURRENT_VESSEL_TTL_MS = 60000;

export const v2_create_user = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_update_user = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_list_user = async (page, limit, filter) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/${page}/${limit}?filter=${encodeURIComponent(filter)}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_crew_history = async (params) => {
    const query = new URLSearchParams(params).toString();
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/crew-history?${query}`;
    return axios.get(url, getAuthHeader()).then((res) => res.data);
}


export const v2_update_user_status = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user`;
    return axios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

/**
 * Permanently delete a user (super-admin only). Cascades through the
 * user-scoped profile tables; the same connected-entity guard the
 * archive flow uses is returned to the UI so the admin can close any
 * remaining vessel assignments / employment records and retry.
 */
export const v2_delete_user = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/${id}`;
    return axios.delete(url, getAuthHeader()).then((res) => res.data);
}



export const v2_personalInformation = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/personal-information`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_identificationDocuments = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/identification-documents`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_update_profile = async (model, section) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/${section}`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v2_update_user_onboarding_status = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/status`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_employmentDetails = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/employment`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_awardDetails = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/awards`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_certificationDetails = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/certifications`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_qualificationDetails = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/qualification`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}





export const v2_experienceDetails = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/experience`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_emergencyContactDetails = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/emergency-contact`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_userStatus = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/status`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_assign_vessel_group_to_crew = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/crew/group/assign`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v2_fetch_grouped_vessel = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/options/grouped-vessels`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_vesselAssignmentDetails = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/vessel-assignment`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_currentWorkingVessel = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/vessel`;
    return cachedGet(CURRENT_VESSEL_KEY, () =>
        catchApi(axios.get(url, getAuthHeader()).then((res) => res.data)),
        CURRENT_VESSEL_TTL_MS
    );
}



/**
 * ✅ Per-item close / delete for a connected record surfaced in the user
 * LinkedEntitiesModal (e.g. one specific vessel assignment or employment
 * record still open for the user being archived).
 */
export const v2_handle_user_linked_item = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/user/linked-item`;
    return axios.post(url, model, getAuthHeader()).then((res) => res.data);
};
